import { render } from "./ImpactSection.vue?vue&type=template&id=1cfea107&scoped=true"
import script from "./ImpactSection.vue?vue&type=script&lang=js"
export * from "./ImpactSection.vue?vue&type=script&lang=js"

import "./ImpactSection.vue?vue&type=style&index=0&id=1cfea107&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfea107"]])

export default __exports__